module.exports = {"name":"options","component":"Select","options":[{"key":"inside"},{"key":"outside"},{"key":"both"}],"validator":"required"};